import List from "@mui/material/List";
import { AppointmentItem } from "./AppointmentItem";

export const AppointmentList = (props: { data: any[] }) => (
  <List>
    {props.data.map((value) => (
      <AppointmentItem data={value} key={value.appointed_to?.company_number ?? value.links?.self} />
    ))}
  </List>
);
